import { Grid } from "@material-ui/core";
import EditAdminInfo from "../components/editAdminInfo";
import EditAdminPassword from "../components/editAdminPassword";
import { UpdateNavigations } from "../store/actions";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import useCustomState from "../hooks/State";

const Profile = (props) => {
  const isLoading = useCustomState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    const navigations = [{ name: "تنظیمات پروفایل", path: "/admin/profile" }];
    dispatch(UpdateNavigations(navigations));
    isLoading.handleChange(false);
  }, []);

  return (
    <>
      <Grid container style={{ paddingRight: "16px", paddingLeft: "16px" }}>
        <EditAdminInfo />
        <EditAdminPassword />
      </Grid>
    </>
  );
};

export default Profile;
